import { Box, Image, Group, Space, ActionIcon } from '@mantine/core';
import { Header } from './Header';
import { MobileNav } from './MobileNav';
import { useApp } from '../../context/AppContext';
import { IconDotsVertical } from '@tabler/icons-react';
import { primaryColor } from '../../constants/theme';
import { useDisclosure } from '@mantine/hooks';
import React from 'react';
import { StipeSetupErrorModal } from '../modals/StripeSetupIssues';
import { QuickActionsMenu } from './QuickActionsMenu';

export const NavigationWrapper = ({
  children,
  disableScroll,
  hideMobileTaskBar,
}: {
  children: React.ReactNode;
  disableScroll?: boolean;
  hideMobileTaskBar?: boolean;
}) => {
  const { isTabletAndBelow } = useApp();

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100dvh',
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <StipeSetupErrorModal />
      {isTabletAndBelow && <CircleBeMobileLogo />}
      {!isTabletAndBelow && <Header />}
      <Box
        style={{
          flex: 1,
          overflowY: disableScroll ? 'hidden' : 'auto',
          minHeight: 0,
        }}
      >
        <Space h={isTabletAndBelow ? 0 : 15} />
        {children}
        {!disableScroll && <Space h={25} />}
      </Box>
      {isTabletAndBelow && !hideMobileTaskBar && <MobileNav />}
    </Box>
  );
};

const CircleBeMobileLogo = () => {
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <>
      <Group
        px={15}
        bg="white"
        align="center"
        justify="space-between"
        w={'100%'}
        h={50}
        style={{ borderBottom: '2px solid #e0e0e0' }}
      >
        <Image
          w={125}
          p={5}
          pt={10}
          src="/logo.png"
          alt="CircleBe Logo"
          fit="contain"
        />
        <ActionIcon variant="transparent" color={primaryColor} onClick={open}>
          <IconDotsVertical />
        </ActionIcon>
      </Group>
      <QuickActionsMenu opened={opened} onClose={close} />
    </>
  );
};
